import type { Theme } from "@mui/material/styles";
import type { AppLayoutContainerStyles, DashboardLayoutOwnerState, MdTheme } from "../types";
import {
  SIDENAV_CONTENT_MARGIN_EXPANDED_PX,
  SIDENAV_CONTENT_MARGIN_MINI_PX,
} from "../tokens/sidenav";

export function buildLayoutContainerStyles(theme: Theme): AppLayoutContainerStyles {
  const mdTheme = theme as MdTheme;
  const { breakpoints, transitions, functions } = mdTheme;
  const { pxToRem } = functions;

  return {
    pageLayout: {
      overflowX: "hidden",
    },
    dashboardLayout: (ownerState: DashboardLayoutOwnerState = {}) => {
      const { miniSidenav = false } = ownerState;
      return {
        p: { xs: 1.25, sm: 1.75, lg: 2 },
        position: "relative",
        minWidth: 0,
        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav
            ? pxToRem(SIDENAV_CONTENT_MARGIN_MINI_PX)
            : pxToRem(SIDENAV_CONTENT_MARGIN_EXPANDED_PX),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      };
    },
  };
}
